import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';
import getFeaturesRequest from './api';
import * as types from './actionTypes';

/**
 * Get features
 *
 * @param params
 */
export default () => async dispatch => {
  try {
    dispatch({
      type: types.GET_FEATURES_REQUEST,
    });

    const { data } = await getFeaturesRequest();

    dispatch({
      type: types.GET_FEATURES_SUCCESS,
      payload: {
        features: data.available_feature_types,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_FEATURES_ERROR,
      payload: {
        error: error.response.data,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};
